/**
 * All global scripts
 */

document.addEventListener('DOMContentLoaded', (event) => {

	// START header fixed
	const header = document.getElementById('header');



	window.addEventListener('scroll', function() {
		if(window.scrollY){
			header.classList.add('fixed');
		}
		else{
			header.classList.remove('fixed');
		}
	});

	// END header fixed

	// START Menu mobile
	if ( window.innerWidth < 1100 ) {

		const menu = new Mmenu( '#menu', {
			"offCanvas": {
				"position": "right"
			},
			"navbar": {
				"title": "Menu"
			},
		});

		const api = menu.API;

		document.querySelector( "#menu__toggle" ).addEventListener( "click", (event) => {
			if ( document.body.classList.contains('mm-wrapper--opened')) {
				api.close();
			} else {
				api.open();
			}
		});
	}
	// END Menu mobile

	// Tronquer second texte enseigne
	//old
	/* let btnTruncate = document.querySelector('.btn-truncate-text');
	if (btnTruncate) {
		btnTruncate.addEventListener('click', function() {
			let text = document.querySelector('.champ_txt_truncate');
			if (text.classList.contains('txt-truncate')) {
				text.classList.remove('txt-truncate');
				text.style.display ="block";
				btnTruncate.innerHTML = 'Lire moins';
			} else {
				text.classList.add('txt-truncate');
				text.style.display ="-webkit-box";
				btnTruncate.innerHTML = 'En savoir plus';
			}
		});
	} */

	let btnTruncate = document.querySelector('.btn-truncate-text');
	if (btnTruncate) {
		btnTruncate.addEventListener('click', function() {
			let text = document.querySelector('.champ_txt_truncate_hide');
			if (text.classList.contains('js-show')) {
				text.classList.remove('js-show');
				btnTruncate.innerHTML = 'En savoir plus';
			} else {
				text.classList.add('js-show');
				btnTruncate.innerHTML = 'Lire moins';
			}
		});
	}

	//let btnTruncateHome = document.querySelector('.btn-truncate-text-centre');
	//if (btnTruncateHome) {
	//	btnTruncateHome.addEventListener('click', function() {
	//		let text = document.querySelector('.bloc_centre_content_mobile');
	//		if (text.classList.contains('txt-truncate-home')) {
	//			text.classList.remove('txt-truncate-home');
	//			text.style.display ="block";
	//			btnTruncateHome.innerHTML = 'Lire moins';
	//		} else {
	//			text.classList.add('txt-truncate-home');
	//			text.style.display ="-webkit-box";
	//			btnTruncateHome.innerHTML = 'Voir plus';
	//		}
	//	});
	//}

	// Check liste catégories
	const urlCourante = document.location.href;
	const urlCategories = document.querySelectorAll('.liste__categories a');
	urlCategories.forEach((element) => element.href === urlCourante ? element.classList.add('active') : null);


	// AOS
	AOS.init();


	// Tronquer second texte enseigne
	// function truncateString(str, length, ending = '...') {
	// 	if (str.length > length) {
	// 	  return str.slice(0, length - ending.length) + ending;
	// 	}
	// 	return str;
	// }

	// const stringTruncate = document.querySelector('.champ_txt_truncate');
	// if (stringTruncate) {
	// 	stringTruncate.innerHTML = truncateString(stringTruncate.innerHTML, 600);
	// }

	// Défilement bannière
	let banniere = document.getElementById('banniere');
	if(banniere){
		let texte = banniere.firstElementChild;
		let tailleTexte = banniere.scrollWidth;

		function defile(){
			let pos = texte.style.marginLeft.replace('px','');
			if(pos < -tailleTexte){
				pos = 200;
			}
			pos -= 10;
			texte.style.marginLeft = pos+"px";
			setTimeout(defile, 180);
		}
		defile();
	}

	/* var checkConfirmation = setInterval(function() {
		var confirmationMessage = document.getElementById('gform_confirmation_message_5');
		if (confirmationMessage) {
			confirmationMessage.scrollIntoView({ behavior: 'smooth' });
			clearInterval(checkConfirmation);
		}}, 700); */

	// Scroll depuis le footer vers le bloc
	const btnNewsletter = document.querySelector('.btn-newsletter');
	function scrollToNewsletter(targetElement) {
		if (targetElement) {
			const elementPosition = targetElement.getBoundingClientRect().top + window.scrollY;
			const offset = window.innerHeight / 2 - targetElement.offsetHeight / 2;

			window.scrollTo({
				top: elementPosition - offset,
				behavior: 'smooth'
			});
		}
	}
	// Fonction pour vérifier l'ancre et effectuer le scroll
	function handleNewsletterAnchor() {
		if (window.location.hash === '#anchor-newsletter') {
			const targetElement = document.querySelector('#anchor-newsletter');
			scrollToNewsletter(targetElement);
		}
	}

	if (btnNewsletter) {
		btnNewsletter.addEventListener('click', function (e) {
			e.preventDefault();
			const targetElement = document.querySelector('#anchor-newsletter');
			if (targetElement) {
				scrollToNewsletter(targetElement);
			} else {
				window.location.href = 'https://www.autre-faubourg.com/#anchor-newsletter';
			}
		});
	}

	window.addEventListener('load', function () {
		handleNewsletterAnchor();
	});



	const newsletterForm = document.querySelector('#gform_5');

	if (newsletterForm) {

		newsletterForm.addEventListener('submit', function (e) {

			// e.preventDefault();

			const targetElement = document.querySelector('#anchor-newsletter');

			if (targetElement) {

				const elementPosition = targetElement.getBoundingClientRect().top + window.scrollY;

				const offset = window.innerHeight / 2 - targetElement.offsetHeight / 2;


				window.scrollTo({
					top: elementPosition - offset,
					behavior: 'smooth'
				});

			}
		});
	}

	// cacher le message unitial du bloc newsletter après soumission du formulaire
	const confirmationWrapper = document.querySelector('.gform_confirmation_wrapper.gform_wrapper');
	if (confirmationWrapper) {
	const newsletterDiv = confirmationWrapper.parentElement.querySelector('.newsletter_js_hide');
	if (newsletterDiv) {
		newsletterDiv.classList.add('js_hide');
	}
	}

	window.addEventListener('load', function () {

		const confirmationWrapper = document.querySelector('#gform_confirmation_wrapper_5');

		const targetElement = document.querySelector('#anchor-newsletter');

		if (confirmationWrapper && targetElement) {

			const elementPosition = targetElement.getBoundingClientRect().top + window.scrollY;
			const offset = window.innerHeight / 2 - targetElement.offsetHeight / 2;

			window.scrollTo({
				top: elementPosition - offset,
				behavior: 'smooth'
			});

		}
	});

}); // end DOMContentLoaded
